import { TYPES } from "./branch.type";

const initState = {
  branchs: [],
  detail: null,
  owerBranches: null,
  detailBranch: null,
};

const branchReducer = (state = initState, action) => {
  const { type, payload } = action;
  switch (type) {
    case TYPES.GET_ALL_BRANCHS_SUCCESS:
      return {
        ...state,
        branchs: payload,
      };
    case TYPES.GET_STAFF_BRANCHS_SUCCESS:
      const extra = payload;
      return {
        ...state,
        branchs: [...state.branchs, ...extra],
      };
    case TYPES.GET_DETAIL_SUCCESS:
      return {
        ...state,
        detail: payload,
      };
    case TYPES.GET_BRANCHS_OWNER_SUCCESS:
      return {
        ...state,
        owerBranches: payload,
      };

    case TYPES.GET_DETAIL_BRANCH_SUCCESS:
      return {
        ...state,
        detailBranch: payload,
      };
    default:
      return state;
  }
};

export default branchReducer;
